/* eslint-disable */
import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

// Material UI table
import { MaterialReactTable } from "material-react-table";

import { assetImages } from "constants";
import { useTranslation } from "react-i18next";

import CRMLabelHeader from "../CRMLabelHeader/CRMLabelHeader";
import TabsHeader from "components/Common/TabsHeader/TabsHeader";
import { crmCommonHeaderLinkLists } from "helper/CrmHelper/CrmHelper";
import AddUpdateLabelPopup from "components/Common/Popup/AddUpdateLabelPopup";
import LabelFilterPopup from "components/Common/Popup/LabelFilterPopup";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";

const CRMLabelBody = () => {
  const token = localStorage.getItem("token");
  const moduleAccess = localStorage.getItem("moduleaccess");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const moduleName = "crmtag";

  /* ------------- Language translation imports starts here ------------- */
  const { t, i18n } = useTranslation();
  // common header object
  const commonHeaderObject = crmCommonHeaderLinkLists(t);

  const [tagList, setTagList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [tagId, setTagId] = useState(null);
  const [isDataReady, setIsDataReady] = useState(false);

  const [rowSelection, setRowSelection] = useState({});
  const [selectLabelIds, setSelectLabelIds] = useState([]);

  const [reloadData, setReloadData] = useState(false);
  const [isFilterReset, setIsFilterReset] = useState(false);

  // json filter query — starts as null so we can distinguish
  // "not yet decided" vs "decided: no filter"
  // null   = filter popup hasn't told us what to do yet (skip API call)
  // []     = filter popup said: no default filter, fetch all
  // [...]  = filter popup said: use these filters
  const [jsonFilterQuery, setJsonFilterQuery] = useState(null);

  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });
  const [lastPagination, setLastPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  //* alert requirements
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  //function for get all tags
  const getAllTags = async (filterQuery = []) => {
    try {
      setIsLoading(true);

      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_TAGS +
        `?modulename=${moduleName}`;

      if (filterQuery.length > 0) {
        requestUrl = requestUrl + `&filters=${JSON.stringify(filterQuery)}`;
      }

      const response = await getData(requestUrl);

      console.log(response);

      setIsLoading(false);

      if (response.status) {
        setTagList(response.data);
        setMessageType("success");
      } else {
        setMessageType("error");
      }

      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    } finally {
      setIsLoading(false);
      setShowAlert(true);
    }
  };

  //function for change status
  const changeStatusHandler = async () => {
    if (selectLabelIds.length > 0) {
      let responseArr = [];

      for (let labelId of selectLabelIds) {
        try {
          let tagData = {
            status: "0",
          };

          let requestUrl =
            url.API_BASE_URL +
            url.API_UPDATE_TAG +
            `/${labelId}` +
            ``;

          const response = await putData(requestUrl, tagData);

          if (response.status) {
            setMessageType("success");
            responseArr.push(true);
          } else {
            setMessageType("error");
          }

          setAlertMessage(response.message);
        } catch (error) {
          setMessageType("error");
          setAlertMessage(error.message);
        }

        setShowAlert(true);
      }

      if (responseArr.length > 0) {
        setTimeout(() => {
          getAllTags();
        }, 2000);
      }
    } else {
      setMessageType("error");
      setAlertMessage("Please select data for delete");
      setShowAlert(true);
    }
  };

  const initialTableColumns = [
    {
      accessorKey: "#",
      header: t("Actions"),
      Cell: ({ row }) => (
        <button
          className="action_btn_mui"
          data-bs-toggle="offcanvas"
          data-bs-target="#addUpdateLabelOffCanvas"
          aria-controls="addUpdateLabelOffCanvas"
          onClick={() => {
            setTagId(row.original.value);
          }}
        >
          <span className="d-block material-symbols-outlined horz_icon">
            more_horiz
          </span>
        </button>
      ),
      enableColumnActions: false, // Hides the column action icon
      enableColumnDragging: false, // Hides the move icon
      enableSorting: false,
    },
    {
      accessorKey: "label",
      header: t("Name"),
      size: 200,
    },
    {
      accessorKey: "slug",
      header: t("Slug"),
      size: 200,
    },
    {
      accessorKey: "createddate",
      header: t("Date"),
      size: 200,
    },
  ];

  /*
   * Material React Table Column and States -----------------------------------------------------------
   *---------------------------------------------------------------------------------------------------
   */
  const columns = useMemo(
    () => initialTableColumns, // initialTableColumns is a constant, so it doesn't need to be in the dependency array
    [i18n.language],
  );

  const initialVisibilityState = initialTableColumns.reduce((acc, column) => {
    acc[column.accessorKey] = true;
    return acc;
  }, {});

  const [visibleColoumns, setVisibleColoumns] = useState(
    initialVisibilityState,
  );

  const onColumnVisiblityHandler = (newColumnState) => {
    const newColumnStateName = newColumnState();
    setVisibleColoumns((prev) => ({ ...prev, ...newColumnStateName }));
  };

  const initialColumnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ];
  const [columnOrder, setColumnOrder] = useState(initialColumnOrder);

  const changeColumnOrderHandler = (changedOrder) =>
    setColumnOrder(changedOrder);

  // ─── Effects ─────────────────────────────────────────────────────────────────

  useEffect(() => {
    //do something when the row selection changes...
    // console.info("rowSelection", rowSelection);
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key],
    );
    if (selectedIdsArray.length > 0) {
      setSelectLabelIds(selectedIdsArray);
    } else {
      setSelectLabelIds([]);
    }
  }, [rowSelection]);

  // Pagination save effect
  useEffect(() => {
    if (pagination.pageIndex > 0 || pagination.pageSize > 10) {
      setLastPagination({
        pageIndex: pagination.pageIndex,
        pageSize: pagination.pageSize,
      });
    }
  }, [pagination.pageIndex, pagination.pageSize]);

  // ✅ Single API trigger — fires only after filter popup has decided what to do.
  // jsonFilterQuery starts as null (popup not ready yet).
  // Popup sets it to [] (no default filter → fetch all) or [...] (has filters → fetch filtered).
  // This way only ONE api call happens — never two.
  useEffect(() => {
    if (jsonFilterQuery === null) return; // Popup hasn't responded yet, wait

    if (jsonFilterQuery.length > 0) {
      getAllTags(jsonFilterQuery); // Filter query exists → filtered fetch
    } else {
      getAllTags([]); // No filter → fetch all
    }

    setIsDataReady(true);
  }, [jsonFilterQuery]);

  // Reload effect — triggered by reset or refresh button
  useEffect(() => {
    if (reloadData) {
      setIsFilterReset(true);
      getAllTags([]);
      setReloadData(false);
      setIsDataReady(true);
    }
  }, [reloadData]);

  //* This is a function that is called when the alert close button is clicked.
  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  //function for reset filter
  const resetFilterData = () => {
    setRowSelection({});
    setSelectLabelIds([]);
    setIsFilterReset(true);
    setJsonFilterQuery([]);
    setReloadData(true);
  };

  const columnReset = () => {
    setVisibleColoumns(initialVisibilityState);
    setColumnOrder(initialColumnOrder);
  };

  const refreshRecords = () => {
    resetFilterData();
    columnReset();
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    (moduleAccess.includes("MOD_CRM") && moduleAccess.includes("MOD_LABEL"))
  ) {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <TabsHeader
            commonHeaderObject={commonHeaderObject}
            activeOption={t("Label")}
          />
          <div className="container-fluid px-lg-5">
            <CRMLabelHeader
              reloadLabelList={refreshRecords}
              jsonFilterQuery={jsonFilterQuery ?? []}
              selectedLabelIds={selectLabelIds}
            />
            {isLoading || !isDataReady ? (
              <LoadingSkeleton />
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns} // map columns to be displayed with api data,
                  data={tagList} // data from api to be displayed
                  enableGrouping
                  enableRowSelection
                  getRowId={(row) => `${row._id}-${row.email}`}
                  onRowSelectionChange={setRowSelection}
                  state={{
                    rowSelection,
                    pagination: lastPagination,
                    columnVisibility: visibleColoumns,
                    columnOrder: columnOrder,
                  }}
                  onPaginationChange={setPagination}
                  initialState={{
                    rowSelection,
                    pagination: lastPagination,
                    columnVisibility: visibleColoumns,
                    columnOrder: columnOrder,
                  }}
                  enableColumnOrdering={true}
                  onColumnVisibilityChange={onColumnVisiblityHandler}
                  onColumnOrderChange={changeColumnOrderHandler}
                  defaultColumn={{ minSize: 20, maxSize: 300, size: 50 }}
                  muiTableContainerProps={{ sx: { maxHeight: "60vh" } }}
                  enableStickyHeader
                />
              </div>
            )}
          </div>
          {/* ==== popup and modal section ==== */}
          {/* ---- filter popup ---- */}
          <AddUpdateLabelPopup
            moduleName={moduleName}
            afterTagModalClose={() => {
              setTimeout(() => {
                getAllTags();
              }, 2500);
            }}
            tagId={tagId}
            setTagId={setTagId}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
          />

          {/* --- label details popup --- */}
          <LabelFilterPopup
            moduleSlug="crmtag"
            visibleColoumns={visibleColoumns}
            setVisibleColoumns={setVisibleColoumns}
            columnOrder={columnOrder}
            setColumnOrder={setColumnOrder}
            setJsonFilterQuery={setJsonFilterQuery}
            reloadList={refreshRecords}
            isFilterReset={isFilterReset}
            setIsFilterReset={setIsFilterReset}
            columns={columns}
          />
          {/* ----------- delete warning modal ------------ */}
          <DeleteWarningModal
            onCancelDelete={() => {
              setRowSelection({});
              setSelectLabelIds([]);
            }}
            onDelete={changeStatusHandler}
            moduleName={t("tag")}
          />
          {showAlert && (
            <AlertNotification
              showAlert={showAlert}
              message={alertMessage}
              alertType={messageType}
              onClose={onAlertClose}
            />
          )}
        </section>
      </div>
    );
  } else {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <div className="empty_access text-center">
            <div className="empty_pic mb-4">
              {" "}
              <img src={assetImages.emptyVector} alt="" />
            </div>
            <div className="empty_text">
              <p className="fs-lg text-gray fw-semibold mb-4">
                {t("Sorry....! You don't have privilege to see this content")}
              </p>
            </div>
          </div>
        </section>
      </div>
    );
  }
};
export default CRMLabelBody;
